import React from 'react';
import { Guideline } from '../../types/profileTypes';
import { BaseRequirementCard } from './BaseRequirementCard';
import { getSummaryText } from './utils';

interface ApprovedQualifierPhrasesBeforeClaimsCardProps {
  guideline: Guideline;
  index: number;
  onEditClick: () => void;
}

export const ApprovedQualifierPhrasesBeforeClaimsCard: React.FC<ApprovedQualifierPhrasesBeforeClaimsCardProps> = ({
  guideline,
  index,
  onEditClick
}) => {
  // Type guard to ensure we have the right guideline type
  if (guideline.type !== 'ApprovedQualifierPhrasesBeforeClaims') {
    return null;
  }

  // Generate the summary text using utils with parameters
  const summaryText = getSummaryText(guideline);

  return (
    <BaseRequirementCard
      index={index}
      summaryText={summaryText}
      title={guideline.name}
      requirementTypeLabel="Approved Qualifier Phrases Before Product Claims"
      onEditClick={onEditClick}
    />
  );
};
